export default __webpack_public_path__ + "static/media/cancel.abaa66f7.svg";